<script setup lang="ts">
  import { useAuthStore } from '@/stores/auth.ts';
  import { useThemeStore } from '@/stores/theme';
  import { ArrowLeftIcon, BoltIcon } from '@heroicons/vue/24/outline';
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';

  interface Props {
    title?: string;
    goBack?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    title: '',
    goBack: false,
  });

  const router = useRouter();
  const authStore = useAuthStore();
  const themeStore = useThemeStore();

  const isModalSettingOn = ref(false);

  function goHistoryBack() {
    router.go(-1);
  }
  function logout() {
    authStore.logout();
  }
</script>

<template>
  <div class="navbar">
    <div class="flex-1">
      <button
        v-if="goBack"
        class="btn btn-ghost normal-case text-lg"
        @click="goHistoryBack">
        <ArrowLeftIcon class="h-5 w-5 -ml-2" />
        <span>{{ title }}</span>
      </button>

      <RouterLink
        v-else
        to="/"
        class="btn btn-ghost normal-case text-xl">
        <BoltIcon class="h-5 w-5 -mr-1 -ml-2" />
        <span>NeoFlex {{ title }}</span>
      </RouterLink>
    </div>

    <div class="flex-none">
      <!-- 소속회사 선택 -->
      <CompanySelect />
      <div class="dropdown dropdown-end">
        <label
          tabindex="0"
          class="btn btn-ghost btn-circle avatar">
          <div class="w-10 rounded-full">
            <img
              :src="authStore.user.photo"
              referrerpolicy="no-referrer" />
          </div>
        </label>
        <ul
          tabindex="0"
          class="menu menu-sm dropdown-content mt-3 z-[100] p-2 shadow rounded-box w-34 text-right"
          :class="{
            'bg-base-100': themeStore.isLight,
            'bg-base-300': themeStore.isDark,
          }">
          <li>
            <ThemeSwitcher />
          </li>
          <li>
            <a
              class="py-2"
              @click="isModalSettingOn = true">
              설정
            </a>
          </li>
          <li class="pt-1">
            <a
              class="py-2"
              @click="logout">
              로그아웃
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <AppSettingModal
    :is-visible="isModalSettingOn"
    @close="isModalSettingOn = false" />
</template>
